<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<ng-template #content let-modal>
  <app-delete-modal
    [heading]="heading()"
    [submitIcon]="submitIcon()"
    [modalType]="modalType()"
    [cancelButtonType]="cancelButtonType()"
    [submitButtonLabel]="submitButtonLabel()"
    [cancelButtonLabel]="cancelButtonLabel()"
    (confirm)="onSubmit(modal)"
    (modalClose)="onCancel(modal)"
  >
    <ng-container body>
      <ng-content select="[body]"></ng-content>
    </ng-container>
  </app-delete-modal>
</ng-template>

<div (click)="open(content)" (keydown.Space)="open(content)">
  <ng-content select="[opener]"></ng-content>
</div>
